import { AfterViewInit, Component, Inject, ModelFunction, Optional, ViewChild, model } from '@angular/core';
import moment from 'moment';

import { DividendModel } from '../dividend.model';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DividendModifyComponent } from '../modify/modify.component';
import { CurrencyPipe } from '../../../shared/pipes/currency.pipe';
import { SharesService } from '../../shares/shares.service';


@Component({
  selector: 'dividend-create',
  standalone: false,
  templateUrl: './create.component.html',
  styleUrl: './create.component.scss'
})
export class DividendCreateComponent implements AfterViewInit {
  
  public dividend: any
  public shares: any

  @ViewChild('createForm', { static: true }) createForm: NgForm | undefined
  public errorMessage: any
  
  constructor(
    private dialogRef: MatDialogRef<DividendModifyComponent>,
    private currencyPipe: CurrencyPipe,
    private shareService: SharesService
  ){
    this.dividend = {
      id: Math.random().toFixed(3),
      share: '',
      date: new Date(),
      amount: 0,
      value: 0.00,
      total: 0.00
    }
  }

  async ngAfterViewInit(): Promise<void> {
    console.error('DividendCreateComponent -> ngAfterViewInit')

    //Update total
    this.createForm?.valueChanges?.subscribe(async (input:any) => {
      // console.error('DividendCreateComponent -> createForm.valueChanges >>>> ', input, this.modifyForm?.controls['dividend.value']?.value)
      
      if(input['dividend.amount'] != undefined && input['dividend.value'] != undefined) {
        this.dividend.total = (parseInt(input['dividend.amount']) * parseFloat(this.currencyPipe.transform(input['dividend.value'], false))).toFixed(2)
        console.error('DividendCreateComponent -> createForm.valueChanges', input['dividend.amount'], this.currencyPipe.transform(input['dividend.value'], false), this.dividend.total)
      }
    })
    
    this.shares = await this.shareService.loadDividendOptions()
    console.error('ShareCreateComponent -> ngAfterViewInit', 'shares', this.shares)
  }

  async onSubmit() {
    console.error('DividendCreateComponent -> onSubmit', this.dividend, this.createForm?.valid)

    if (this.createForm?.valid)
      this.dialogRef.close({
        data: {
          response: 'Dividend created!',
          values: { 
            ...this.dividend, 
            amount: this.createForm.value['dividend.amount'].toString(), 
            value: parseFloat(this.currencyPipe.transform(this.createForm.value['dividend.value'], false)),
            total: parseFloat(this.currencyPipe.transform(this.createForm.value['dividend.total'], false)),
          }
        }
      })
    else
      this.errorMessage = "Errorrrrr"
  }
}
